import { data } from 'services';
import { getList, getDateTime } from 'services/types';
import { ParkingCell } from 'libs/ui';

export const getTableParams = (inList = true, t, categories, vehicleClasses) => {
  // get row class
  const getRowClass = (row) => {
    let out = '';
    out += row.status === 'active' ? ' active' : ' archive';
    return out;
  };

  // get fields
  const getFields = () => {
    const fields = [
      { name: 'name', title: t('grid.Название'), width: 280, sortField: 'name' },
      {
        name: 'type',
        title: t('dict_filter.Тип'),
        width: 240,
        sortField: 'type',
        render: (val) => data.getDictValue('tariff.type', val),
      },
      {
        name: 'status',
        title: t('grid.Статус'),
        width: 115,
        sortField: 'status',
        render: (val) => data.getDictValue('tariff.status', val),
      },
      { name: 'created_at', title: t('form.Дата создания'), width: 210, sortField: 'created_at', render: (val) => getDateTime(val, true) },
      { name: 'time_from', title: t('form.Начало действия'), width: 210, sortField: 'time_from', render: (val) => getDateTime(val, true) },
      {
        name: 'vehicle_category',
        title: t('form.Категория'),
        width: 165,
        sortField: 'vehicle_category',
        render: (val) => getList(categories, val),
      },
      {
        name: 'vehicle_class',
        title: t('dict_filter.Класс ТС'),
        width: 200,
        sortField: 'vehicle_class',
        render: (val) => getList(vehicleClasses, val),
      },
    ];

    if (window.config.central) {
      fields.unshift({
        name: 'parking_id',
        title: t('grid.Парковка'),
        render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
        width: 140,
      });
    }

    if (inList) {
      fields.forEach((field) => {
        delete field.sortField;
      });
    }

    return fields;
  };

  return { getFields, getRowClass };
};
